import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveWorkspaceId } from '../redux/usersSlice';

/**
 * Only workspace super admins may access the setup route for a workspace.
 * Syncs active workspace to the URL workspace id when valid.
 */
const WorkspaceSetupGuard = ({ children }) => {
    const { workspaceId } = useParams();
    const dispatch = useDispatch();
    const memberships = useSelector(state => state?.user?.memberships || []);
    const workspacesLoading = useSelector(state => state?.user?.workspacesLoading);
    const activeWorkspaceId = useSelector(state => state?.user?.activeWorkspaceId);

    const membership = memberships.find(m => String(m?.workspace?.id) === String(workspaceId));

    React.useEffect(() => {
        if (!workspaceId || !membership || workspacesLoading) return;
        if (String(activeWorkspaceId) !== String(workspaceId)) {
            dispatch(setActiveWorkspaceId(workspaceId));
        }
    }, [workspaceId, membership, workspacesLoading, activeWorkspaceId, dispatch]);

    if (workspacesLoading) {
        return null;
    }

    if (!membership) {
        return <Navigate to="/project" replace />;
    }

    if (membership.role !== 'WORKSPACE_SUPER_ADMIN') {
        return <Navigate to="/project" replace />;
    }

    if (membership.workspace?.is_setuped !== false) {
        return <Navigate to="/project" replace />;
    }

    return children;
};

export default WorkspaceSetupGuard;
